<template>
  <div class="kpi-tesk-page">
    <van-cell :title="stepDetail.name" class="tip" />
    <div class="flex">
      <span>时间</span>
      <span>{{stepDetail.startTime}} - {{stepDetail.finishTime}}</span>
    </div>

    <van-cell-group>
      <!-- <van-cell title="阶段品牌任务金" :value="stepDetail.brandBonusPool" value-class="value" /> -->
      <van-cell title="阶段导购员奖励金" :value="stepDetail.staffBonusPool" value-class="value" />
    </van-cell-group>

    <div class="display bottom-line">
      <div class="tip">所有导购员任务统一设置</div>
      <div>
        <van-button size="small" round class="set-btn mr10" @click="setStaff">设置</van-button>
        <van-button type="info" size="small" @click="savestaff" round>保存</van-button>
      </div>
    </div>

    <div>
      <div class="field">
        <div class="input line">
          <div>浏览数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.viewNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>裂变数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.fissionNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>报名数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.enrollmentNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>售券数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.cardNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>秒杀数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.seckillUserNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>集赞数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.thumbNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>进入直播间数量</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.liveViewNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>直播下订</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.liveOrderCusNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签单</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.liveSelfOrderNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>直播贡献单</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.liveOtherOrderNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签转单</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.liveSelfOrderChangeNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>直播贡献转单</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.liveOtherOrderChangeNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>过程自签单</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.processSelfOrderNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
        <div class="input line">
          <div>过程贡献单</div>
          <van-field
            type="number"
            v-model.number="staffStepVO.processDevoteOrderNum"
            :class="staff_css?'staff-focus':''"
            :readonly="!staff_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播预约数量</div>
          <van-field
              type="number"
              v-model.number="staffStepVO.appointmentNum"
              :class="staff_css?'staff-focus':''"
              :readonly="!staff_css"
          />
        </div>
        <div class="input line"></div>
      </div>
    </div>

    <div class="display bottom-line">
      <div class="tip">所有品牌任务统一设置</div>
      <div>
        <van-button size="small" round class="set-btn mr10" @click="setBrand">设置</van-button>
        <van-button type="info" size="small" @click="savebrand" round>保存</van-button>
      </div>
    </div>

    <div>
      <div class="field">
        <div class="input line">
          <div>浏览数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.viewNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>浏览惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.viewPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>裂变数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.fissionNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>裂变惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.fissionPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>

      <div class="field">
        <div class="input line">
          <div>报名数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.enrollmentNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>报名惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.enrollmentPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>

      <div class="field">
        <div class="input line">
          <div>售券数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.cardNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>售券惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.cardPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>秒杀数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.seckillUserNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>秒杀惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.seckillUserPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>集赞数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.thumbNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>集赞惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.thumbPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>

      <div class="field">
        <div class="input line">
          <div>进入直播间数量</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveViewNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>进入直播间惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveViewPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播下订</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveOrderCusNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>直播下订惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveOrderCusPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签单订单</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveSelfOrderNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>直播自签单惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveSelfOrderPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播贡献单订单</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveOtherOrderNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>直播贡献单惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveOtherOrderPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签转单</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveSelfOrderChangeNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>直播自签转单惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveSelfOrderChangePenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播贡献转单</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveOtherOrderChangeNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>直播贡献转单惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.liveOtherOrderChangePenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>过程自签单</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.processSelfOrderNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>过程自签单惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.processSelfOrderPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>过程贡献单</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.processDevoteOrderNum"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>过程贡献单惩罚金</div>
          <van-field
            type="number"
            v-model.number="brandStepVO.processDevoteOrderPenalty"
            :class="brand_css?'brand-focus':''"
            :readonly="!brand_css"
          />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播预约</div>
          <van-field
              type="number"
              v-model.number="brandStepVO.appointmentNum"
              :class="brand_css?'brand-focus':''"
              :readonly="!brand_css"
          />
        </div>
        <div class="input line">
          <div>直播预约惩罚金</div>
          <van-field
              type="number"
              v-model.number="brandStepVO.appointmentPenalty"
              :class="brand_css?'brand-focus':''"
              :readonly="!brand_css"
          />
        </div>
      </div>
    </div>
    <van-cell
      title="所有品牌调整设置"
      is-link
      value="去设置"
      class="bottom"
      :to="{ name: 'kpi.basic.tasks', query: { step_id: step_id }}"
    />
    <!-- <van-cell
      title="所有品牌调整设置"
      is-link
      value="去设置"
      class="bottom"
      :to="{ name: 'kpi.brandset', params: { step_id: step_id }, query: { activity_id: activity.id, user_id: user_id, kpi_uid: kpi_uid, share_uid: share_uid }}"
    />-->

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      stage: {},
      staff_css: false,
      brand_css: false,
      curId: null,
      user: null,
      kpi_user: null,
      step_id: 0,
      // 导购员参数
      staffStepVO: {
        viewNum: 0,
        fissionNum: 0,
        enrollmentNum: 0,
        cardNum: 0,
        seckillUserNum: 0,
        thumbNum: 0,
        liveViewNum: 0,
        liveOrderCusNum: 0,
        liveSelfOrderNum: 0,
        liveOtherOrderNum: 0,
        liveSelfOrderChangeNum: 0,
        liveOtherOrderChangeNum: 0,
        processSelfOrderNum: 0,
        processDevoteOrderNum: 0,
        appointmentNum: 0,
      },
      // 品牌参数
      brandStepVO: {
        viewNum: 0,
        viewPenalty: 0,
        fissionNum: 0,
        fissionPenalty: 0,
        enrollmentNum: 0,
        enrollmentPenalty: 0,
        cardNum: 0,
        cardPenalty: 0,
        seckillUserNum: 0,
        seckillUserPenalty: 0,
        thumbNum: 0,
        thumbPenalty: 0,
        liveViewNum: 0,
        liveViewPenalty: 0,
        liveOrderCusNum: 0,
        liveOrderCusPenalty: 0,
        liveSelfOrderNum: 0,
        liveSelfOrderPenalty: 0,
        liveOtherOrderNum: 0,
        liveOtherOrderPenalty: 0,
        liveSelfOrderChangeNum: 0,
        liveSelfOrderChangePenalty: 0,
        liveOtherOrderChangeNum: 0,
        liveOtherOrderChangePenalty: 0,
        processSelfOrderNum: 0,
        processSelfOrderPenalty: 0,
        processDevoteOrderNum: 0,
        processDevoteOrderPenalty: 0,
        appointmentNum: 0,
        appointmentPenalty: 0,
      },
      stepDetail: {
        name: "活动名称",
        startTime: "开始时间",
        finishTime: "结束时间",
        staffBonusPool: 0,
        brandBonusPool: "nodata",
      },
    };
  },
  mounted() {
    this.step_id = this.$route.query.step_id;
    this.getQueryStepDetail();
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
    // this.getStage(this.step_id);
    // this.getUser();
  },

  methods: {
    // 获取当前阶段任务信息，准备编辑
    async getQueryStepDetail() {
      var id = this.step_id;
      let res = await this.$http.post(
        `/v1/taskmanage/query_step_details?stepId=${id}`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        if (res.data.brandStepVO) {
          this.brandStepVO = res.data.brandStepVO;
        }
        if (res.data.staffStepVO) {
          this.staffStepVO = res.data.staffStepVO;
        }
        this.stepDetail = res.data;
      } else {
        this.$toast(res.msg);
      }
    },
    async savebrand() {
      this.brandStepVO.stepId = this.step_id;
      let res = await this.$http.post(
        `/v1/taskmanage/save_or_update_bs`,
        this.brandStepVO
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("设置成功！");
        this.getQueryStepDetail();
      } else {
        this.$toast(res.msg);
      }
    },
    async savestaff() {
      this.staffStepVO.stepId = this.step_id;
      let res = await this.$http.post(
        `/v1/taskmanage/save_or_update_ss`,
        this.staffStepVO
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("设置成功！");
        this.getQueryStepDetail();
      } else {
        this.$toast(res.msg);
      }
    },

    /**
     * 获取阶段信息
     * @param id
     */
    getStage(step_id) {
      this.$fn.showLoading();
      this.$fn.get("steps/" + step_id, {}, (res) => {
        this.$fn.closeLoading();
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.stage = res.data;
      });
    },
    setStaff() {
      this.brand_css = false;
      this.staff_css = true;
    },
    setBrand() {
      this.staff_css = false;
      this.brand_css = true;
    },
    /**
     * 获取用户信息
     */
    getUser() {
      this.$fn.get("user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "success") {
          this.user = res.data;
        }
        this.getKpiUser();
      });
    },
    getKpiUser() {
      this.$fn.get("kpi/user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "success") {
          this.kpi_user = res.data; // type: 3--导购员  type: 2--品牌负责人 type: 1--活动负责人
        }
        this.this.$fn.commonShare(this.activity, this.user, this.kpi_user);
      });
    },
  },
};
</script>

<style lang="less">
.kpi-tesk-page {
  .tip {
    font-weight: bold;
  }
  .flex {
    background-color: #ffffff;
    padding: 10px 15px;
    span:last-child {
      color: #3283fa;
    }
  }
  .value {
    /*van-cell的value自定义类*/
    color: #3283fa;
  }
  .van-cell:not(:last-child)::after {
    left: 0px;
  }

  .display {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    padding: 12px 15px;
    .img {
      max-width: 60%;
      display: flex;
      align-items: center;
      img {
        width: 70px;
        height: 50px;
      }
      span {
        padding: 0;
        margin: 0;
        margin-left: 10px;
        border: none;
        color: #323232;
        max-width: 60%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .field {
    /*将两个输入框水平放置*/
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    .line {
      padding: 7px 15px;
      width: 50%;
      font-size: 12px;
    }
  }
  .input {
    /*将两个输入框水平放置*/
    display: flex;
    padding: 10px 15px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    color: #323232;
    .van-cell {
      width: 40%;
      font-size: 18px;
      padding: 0px;
      .van-field__control {
        text-align: right;
        font-size: 14px;
        color: #5293fd;
        padding: 0 5px;
        line-height: 22px;
      }
    }
  }
  .staff-focus,
  .brand-focus {
    .van-field__control {
      background-color: #eeeeee;
      border-radius: 2px;
      text-align: left !important;
    }
  }
  .bottom {
    margin: 10px 0;
  }
  .van-button--small {
    height: 24px;
    line-height: 22px;
  }
  .set-btn {
    background-color: #f58022;
    color: #ffffff;
  }
}
</style>
